import { fetchData } from "../../Helpers";

export const REDIRECT_STALE_TIME = 1000 * 60 * 5.5;
export const REDIRECT_CACHE_TIME = Infinity;

export function getIdentify({ payload }) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/consumer/redirect/identify",
    successCallback: () => { },
    payload,
    controller: controller,
  });
}

export function getToken(touchpoint) {
  const controller = new AbortController();
  return fetchData({
    endpoint: `/consumer/redirect/token?touchpoint=${touchpoint}`,
    successCallback: () => { },
    controller: controller,
  });
}


